import { render, staticRenderFns } from "./ProjectToothSelectorPopup.vue?vue&type=template&id=dc3e7f0e"
import script from "./ProjectToothSelectorPopup.vue?vue&type=script&lang=js"
export * from "./ProjectToothSelectorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports